export default "__VITE_ASSET__3837469b__"